import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from "@angular/router";
import { UiService } from '../../../../services/ui.service';
import { HeaderService } from '../../../../services/headerService';
import { MatDialog } from '@angular/material/dialog';
import { ContactUsComponent } from '../../portal/modals/contact-us/contact-us.component';
// import { MsalService } from 'src/shared/msalService';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss']
})
export class GlobalHeaderComponent implements OnInit {
  isNavActive: boolean = false;
  isSubOpen: boolean = false;
  isUserDropdownActive: boolean = false;
  routeParent: string[];
  resRoute: boolean = false;
  isEnrollment: boolean;
  cleanURI: string;
  isTabletMenuOpen: boolean = false;
  isTabletMode: boolean = false;

  // get firstName(): string {
  //   return this.portalService.patientProfile && this.portalService.patientProfile.firstName || '';
  // };
  isTablet: boolean = false;
  onRes: boolean;

  constructor(
    // private msalservice: MsalService,
    private router: Router,
    public uiService: UiService,
    // private portalService: PortalService,
    private headerService: HeaderService,
    private dialog: MatDialog,
  ) {
    //determines if it is in enrollment
    /*
    this.router.events.subscribe( event => {
      if ( event instanceof NavigationEnd ) {
        this.isSubOpen = false;
        this.cleanURI = event.url.split('?')[0];
        this.routeParent = this.cleanURI.split( '/' ).filter( r => r !== '' );
        this.setRouteParent( this.routeParent[0] === 'enroll' );
        this.resRoute = this.routeParent[0] === 'resources';
        this.stickyHeader( true );
      }
    } );
    */
  }

  @Output() onMenuOpen: EventEmitter<any> = new EventEmitter();
  @Output() logoutEvent = new EventEmitter<void>();

  ngOnInit() {
    // if (this.msalservice.hasTokenExpired()) {
    //   this.uiService.isLoggedIn = false;
    // } else {
    this.uiService.isLoggedIn = true;
    this.updateTabletMode();
    window.addEventListener('resize', this.updateTabletMode.bind(this));
    // }


    // this.stickyHeader(false);

    //device detection if you are on a tablet device or not
    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet = /(ipad|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    this.isTablet = isTablet;

  }
  ngOnDestroy() {
    window.removeEventListener('resize', this.updateTabletMode.bind(this));
  }

  toggleTabletMenu() {
    this.isTabletMenuOpen = !this.isTabletMenuOpen;
  }

  private updateTabletMode() {
    const width = window.innerWidth;
    this.isTabletMode = width >= 768 && width <= 1024;
  }

  onLogout() {
    this.logoutEvent.emit();
  }

  onProfileClick() {

  }
  // toggleMenu() {
  //   const navbarItems = document.querySelector(‘.navbar-items’);
  //   navbarItems.style.display = navbarItems.style.display === ‘flex’ ? ‘none’ : ‘flex’;
  // }

  stickyHeader(fromrt: boolean) {
    //sticky header disappear/reappear
    let refOffset = 0;
    const bannerHeight = 146;

    if (fromrt) {
      this.headerService.showHeader(true);
    } else {
      const handler = () => {
        const newOffset = window.scrollY || window.pageYOffset;

        if (newOffset > bannerHeight) {
          if (newOffset > refOffset) {
            this.headerService.showHeader(false);
          } else {
            this.headerService.showHeader(true);
          }

          refOffset = newOffset;
        }
      }

      window.addEventListener('scroll', handler, false);

    }
  }

  //sets inEnrollment to true or false (for right now only to hide the enroll now button in header while in enrollment)
  setRouteParent(r: boolean) {
    this.isEnrollment = r;
  }

  openMenu() {
    const mobile = 768;
    if (window.innerWidth <= mobile) this.isNavActive = !this.isNavActive;
    this.isSubOpen = false;

    //open submenu on resources if you are on a resources page
    if (this.resRoute) {
      this.isSubOpen = true;
    }

  }

  showUserDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isUserDropdownActive = true;
  }

  hideUserDropdown() {
    this.isUserDropdownActive = false;

  }

  openSubnavClick() {
    if (this.isSubOpen) {
      this.isSubOpen = false;
    } else {
      this.isSubOpen = true;
    }
  }

  login() {
    // this.msalservice.login();
  }

  logout() {
    // this.msalservice.logout();
  }

  goToCart() {
    this.router.navigate(['portal', 'cart']);
  }

  goToProfile() {
    this.router.navigate(['portal', 'profile-summary']);
    this.hideUserDropdown();
  }

  goToDashboard() {
    this.router.navigate(['portal', 'dashboard']);
    this.hideUserDropdown();
  }

  goToDocuments() {
    this.router.navigate(['portal', 'documents']);
    this.hideUserDropdown();
  }
  openModal(event: Event): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(ContactUsComponent, {
      minWidth: '50vw', minHeight: '70vh', autoFocus: false, disableClose: true,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('User selected:', result);
      } else {
        console.log('Modal closed without selection');
      }
    });
  }
}
